import React, { useState } from "react";
import withLayout from "../../../hocs/Layout";
import { apiConstants, postMultipart } from "../../../common/constants";
import { FormProvider, RHFFileField } from "../../../common/hook-form";
import { useForm } from "react-hook-form";
import { Box, Button, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PageTitle from "../../../common/PageTitle";
import { useSnackbar } from "notistack";
import { getMerchant } from "../../../helpers/ReduxHelpers";
import DownloadSampleFile from "../../../common/DownloadSampleFile";
import { FONT, SIZE, WEIGHT } from '../../../styles/foundation/typography';
import { NAVY } from '../../../styles/foundation/colors';
import {
    pageContainerSx, 
    uploadSectionSx, primaryBtnSx, secondaryBtnSx,
    helpTextSx, helpTextTypeSx, btnRowSx,
} from '../../../styles/patterns';

const SorterImage = () => {
    const { enqueueSnackbar } = useSnackbar();
    const [isUploadingFile, setIsUploadingFile] = useState(false);
    const merchant = getMerchant();
    const merchantId = merchant.id ? merchant.id : '';
    const [excelLink, setExcelLink] = useState(null);

    const methodsBulkUpload = useForm({ defaultValues: { orderFile: null } });
    const { handleSubmit, reset } = methodsBulkUpload;

    const onSubmit = async (data) => {
        setIsUploadingFile(true);
        try {
            const formData = new FormData();
            formData.append("excelFile", data.orderFile[0]);
            formData.append("merchantOid", merchantId);
            const response = await postMultipart(`${apiConstants.SORTER_IMAGE_DOWNLOAD}`, formData);
            if (response.status === 200 && response?.data?.excel) {
                setExcelLink(response?.data?.excel);
                enqueueSnackbar("Successfully Uploaded!", { variant: "success" });
            } else {
                enqueueSnackbar(response.data, { variant: "error" });
            }
        } catch (error) {
            enqueueSnackbar(error?.response?.data?.message || "Error uploading file", { variant: "error" });
        } finally {
            setIsUploadingFile(false);
        }
    };

    return (
        <Box sx={pageContainerSx}>
            <PageTitle>Sorter Image Download</PageTitle>

            {/* <Box sx={pageHeroSx}>
                <Typography sx={heroTitleSx}>Sorter Image Download</Typography>
                <Typography sx={heroSubSx}>Upload an XLSX file with AWB numbers to download sorter images</Typography>
            </Box> */}

            <Box sx={uploadSectionSx}>
                <Typography sx={{ fontFamily: FONT, fontSize: SIZE.md, fontWeight: WEIGHT.bold, color: NAVY, mb: 1.5 }}>
                    Upload AWB File
                </Typography>
                <Box sx={helpTextSx}>
                    <InfoOutlinedIcon sx={{ fontSize: 16, color: '#3783e7', mt: 0.2 }} />
                    <Typography sx={helpTextTypeSx}>
                        <strong>How it works:</strong> Upload an XLSX file containing AWB numbers.
                        The system will generate sorter images and provide a downloadable Excel link.
                    </Typography>
                </Box>

                <FormProvider methods={methodsBulkUpload} onSubmit={handleSubmit(onSubmit)}>
                    <RHFFileField name="orderFile" fileType={["xlsx"]} required={true} />
                    <Box sx={{ ...btnRowSx, mt: 2 }}>
                        <LoadingButton startIcon={<FileUploadIcon />} type="submit" loading={isUploadingFile}
                            variant="contained" size="small" sx={primaryBtnSx}>
                            Upload
                        </LoadingButton>
                        <DownloadSampleFile fileName={"BULK_SORTER_IMAGE_DOWNLOAD_BY_AWB"} label='Download Sample' excel={'excel'} />
                        <Button variant="outlined" size="small" sx={secondaryBtnSx}
                            startIcon={<RestartAltIcon />} onClick={() => { reset(); setExcelLink(null); }}>
                            Reset
                        </Button>
                        {excelLink && (
                            <Button variant="contained" size="small" sx={primaryBtnSx}
                                href={excelLink} target="_blank" startIcon={<FileDownloadIcon />}>
                                Download Excel
                            </Button>
                        )}
                    </Box>
                </FormProvider>
            </Box>
        </Box>
    );
};
export default withLayout(SorterImage);
